import React, {useEffect, useState} from 'react';
import {
    Box,
    Checkbox,
    Dialog,
    DialogContent,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import {ActiveTrend} from "../../../../types/nbaTypes";
import {useIsAdminUser} from "../../../../hooks/isAdminUser/isAdminUser";
import {SaveTrendButton} from "../../../atoms/SaveTrendButton/SaveTrendButton";
import {log} from "util";
import {useSaveTrend} from "../../../../hooks/saveTrend";

export const EditTrendDialog = (
    {
        handleOpenEditDialog,
        isOpen,
        trend
    }:
    {
        handleOpenEditDialog: (e: any, trend?: ActiveTrend) => void,
        isOpen: boolean,
        trend?: ActiveTrend
    }
) => {

    const theme = useTheme()
    const [errorMessage, setErrorMessage] = useState('');
    const [description, setDescription] = useState('');
    const [isSuTrend, setIsSuTrend] = useState(false);
    const [isAtsTrend, setIsAtsTrend] = useState(false);
    const [isOuTrend, setIsOuTrend] = useState(false);
    const [isDefaultTrend, setIsDefaultTrend] = useState(false);
    const [isDefaultUserTrend, setIsDefaultUserTrend] = useState(false);
    const { data } = useIsAdminUser()
    const {saveTrend, error, reset} = useSaveTrend()
    const { isAdminUser } = data || {};

    const handleSetDescription = (e: any, description: string = '') => {
        e.stopPropagation();
        setDescription(description);
    }

    useEffect(() => {
        if(!!trend) {
            setDescription(trend.trendDescription)
            setIsAtsTrend(!!trend.isAtsTrend)
            setIsOuTrend(!!trend.isOuTrend)
            setIsSuTrend(!!trend.isSuTrend)
            setIsDefaultTrend(!!trend.isDefaultTrend)
            setIsDefaultUserTrend(!!trend.isDefaultUserTrend)
        }
    }, [
        trend?.isAtsTrend,
        trend?.isOuTrend,
        trend?.isSuTrend,
        trend?.isDefaultTrend,
        trend?.isDefaultUserTrend
    ])

    const handleSubmit = async (e: any) => {
        try {
            const saveTrendResponse = await saveTrend(
                trend?.trend || '',
                isSuTrend,
                isAtsTrend,
                isOuTrend,
                isDefaultTrend,
                isDefaultUserTrend,
                trend?.sport || 'ncaabb',
                undefined,
                description,
                undefined,
                trend?.id || '',
            );
            if(saveTrendResponse?.data?.saveTrend?.id) {
                handleOpenEditDialog(e, trend)
            }
            if(saveTrendResponse?.errors?.length) setErrorMessage(saveTrendResponse?.errors?.[0]?.message)
        } catch (err) {
            console.error("Login error:", err);
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(e) => handleOpenEditDialog(e, trend)}
            aria-autocomplete="none"
        >
            <DialogContent
                aria-autocomplete="none"
                // onClick={(e) => e.stopPropagation()}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignContent: 'center',
                    minWidth: 360,
                }}
            >
                <Typography
                    variant="caption"
                    component="p"
                    style={{color: 'grey'}}
                    ml={'auto'}
                    mr={'auto'}
                >
                    Update Trend:
                </Typography>
                {errorMessage && (
                    <Typography
                        variant="caption"
                        color={theme.palette.error.main}
                        fontWeight={600}
                        align="center"
                    >
                        {errorMessage}
                    </Typography>
                )}
                <Typography
                    variant="subtitle1"
                    component="span"
                    align={"center"}
                >
                    {trend?.trend}
                </Typography>
                <TextField
                    onChange={
                        (e) =>
                            handleSetDescription(e, e.target.value)
                    }
                    value={description}
                    style={{
                        marginTop: '8px',
                    }}
                    placeholder={'Enter New Trend Description'}
                />
                <FormGroup
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'row',
                        marginTop: '12px',
                    }}
                >
                    <FormControlLabel
                        style={{marginLeft: '4px'}}
                        control={
                            <Checkbox
                                style={{padding: '0', paddingRight: '4px'}}
                                onChange={() => setIsSuTrend(!isSuTrend)}
                                checked={isSuTrend}
                            />
                        }
                        label="SU"
                    />
                    <FormControlLabel
                        style={{marginLeft: '4px'}}
                        control={
                            <Checkbox
                                style={{padding: '0', paddingRight: '4px'}}
                                onChange={() => setIsAtsTrend(!isAtsTrend)}
                                checked={isAtsTrend}
                            />
                        }
                        label="ATS"
                    />
                    <FormControlLabel
                        style={{marginLeft: '4px'}}
                        control={
                            <Checkbox
                                style={{padding: '0', paddingRight: '4px'}}
                                onChange={() => setIsOuTrend(!isOuTrend)}
                                checked={isOuTrend}
                            />
                        }
                        label="OU"
                    />
                    <Box width="100%" display="flex" justifyContent="center" mt={1}>
                        <FormControlLabel
                            style={{marginLeft: '4px'}}
                            control={
                                <Checkbox
                                    style={{padding: '0', paddingRight: '4px'}}
                                    onChange={() => setIsDefaultTrend(!isDefaultTrend)}
                                    checked={isDefaultTrend}
                                />
                            }
                            label="Homepage Trend"
                        />
                        {isAdminUser && (
                            <FormControlLabel
                                style={{marginLeft: '4px'}}
                                control={
                                    <Checkbox
                                        style={{padding: '0', paddingRight: '4px'}}
                                        onChange={() => setIsDefaultUserTrend(!isDefaultUserTrend)}
                                        checked={isDefaultUserTrend}
                                    />
                                }
                                label="Default User Trend"
                            />
                        )}
                    </Box>
                    <SaveTrendButton
                        handleSubmit={(e) => handleSubmit(e)}
                        queryString={trend?.trend || ''}
                    />
                </FormGroup>
            </DialogContent>
        </Dialog>
    );
}